import * as actions from './actions';
import * as selectors from './selectors';

// export { PromotionDispatch } from './actions';
export { promotion } from './reducer';
// export { PromotedGame, PromotionAppState } from './types';
export const Promotion = { ...actions, ...selectors };
